"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countUploadingFilesByType = countUploadingFilesByType;
exports.getDecreasedQuantityUsed = getDecreasedQuantityUsed;
exports.getIncreasedQuantityUsed = getIncreasedQuantityUsed;
exports.updateAttemptedVideoUploads = exports.isOrWillVideoLimitBeReached = void 0;

var _Constants = require("FileManagerCore/Constants");

var _file = require("FileManagerCore/utils/file");

function countUploadingFilesByType(uploadingFiles, fileType) {
  return uploadingFiles.filter(function (file) {
    return (0, _file.getType)((0, _file.splitNameAndExtension)(file).extension) === fileType;
  }).length || 0;
}

var isOrWillVideoLimitBeReached = function isOrWillVideoLimitBeReached(_ref) {
  var hasUserExceededVideoLimit = _ref.hasUserExceededVideoLimit,
      attemptedVideoUploadsCount = _ref.attemptedVideoUploadsCount,
      quantityUsed = _ref.quantityUsed,
      quantityAllowed = _ref.quantityAllowed;
  return hasUserExceededVideoLimit || attemptedVideoUploadsCount + quantityUsed >= quantityAllowed;
};

exports.isOrWillVideoLimitBeReached = isOrWillVideoLimitBeReached;

var updateAttemptedVideoUploads = function updateAttemptedVideoUploads(state, newValue) {
  return state.get(_Constants.Limits.EMBEDDABLE_VIDEO).merge({
    attemptedVideoUploads: newValue
  });
};

exports.updateAttemptedVideoUploads = updateAttemptedVideoUploads;

function getDecreasedQuantityUsed(state, count) {
  return state.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed']) - count;
}

function getIncreasedQuantityUsed(state, count) {
  return state.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed']) + count;
}